<script lang="ts">var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { getFirstSourceStore, getTemplatedElementDataFromSource, } from "../../../utilities";
import { resolveUrl } from "../../../../../js/url";
export let element;
export let sources;
$: source = getFirstSourceStore($sources);
$: backgroundColor = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.backgroundColor) || "";
$: image = String(((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.image) || "");
$: fontFace = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.fontFace) || "";
$: title = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.title) || "";
$: titleColor = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.titleColor) || "";
$: detail = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.detail) || "";
$: detailColor = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.detailColor) || "";
$: detailMargin = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.detailMargin) || "margin: 8px 0 6px 0;";
$: button = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.button) || "";
$: buttonColor = ((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.buttonColor) || "";
$: buttonBackgroundColor = ((_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.buttonBackgroundColor) || "";
$: buttonBorderRadius = ((_m = element === null || element === void 0 ? void 0 : element.data) === null || _m === void 0 ? void 0 : _m.buttonBorderRadius) || "4px";
$: clickUrl = resolveUrl(String((_o = element === null || element === void 0 ? void 0 : element.data) === null || _o === void 0 ? void 0 : _o.clickUrl)).href || "";
</script>

<CardBase {element}>
  <div class="redeem-cta">
    <div class="card" style={`background: ${backgroundColor};`}>
      <div
        class="title"
        style={`color: ${titleColor}; font-family: ${fontFace};`}
      >
        {title}
      </div>
      <div
        class="description"
        style={`color: ${detailColor}; font-family: ${fontFace}; margin: ${detailMargin};`}
      >
        {detail}
      </div>
      <a
        class="link"
        href={clickUrl}
        style={`color: ${buttonColor}; background: ${buttonBackgroundColor}; font-family: ${fontFace}; border-radius: ${buttonBorderRadius};`}
      >
        {button}
      </a>
      {#if image}
      <div class="img-wrapper">
        <img class="img" src={image} />
      </div>
      {/if}
    </div>
  </div>
</CardBase>

<style type="text/scss">*,
*:before,
*:after {
  box-sizing: border-box;
}

.card {
  padding: 10px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: 700;
}

.description {
  font-size: 14px;
  margin: 8px 0 6px 0;
}

.link {
  display: flex;
  width: 100%;
  height: 40px;
  font-weight: 700;
  font-size: 16px;
  border-radius: 4px;
}

.img-wrapper {
  position: absolute;
  width: 148px;
  height: 155px;
  bottom: 0;
  right: 0px;
}

.img-wrapper .img {
  width: 100%;
  height: 100%;
}</style>
